import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const BulkPricingModal = ({ category, categoryInfo, onClose, onSuccess }) => {
  const [changeType, setChangeType] = useState('percentage');
  const [priceChange, setPriceChange] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!priceChange || isNaN(priceChange)) return;

    setLoading(true);
    try {
      const response = await axios.put(
        `${API_BASE_URL}/api/tickets/category/${category}/bulk-price`,
        {
          priceChange: parseFloat(priceChange),
          changeType
        }
      );
      
      onSuccess(response.data.message);
      onClose();
    } catch (error) {
      alert('Error updating prices: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '16px',
        padding: '32px',
        maxWidth: '400px',
        width: '100%',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
          <span style={{ fontSize: '32px' }}>{categoryInfo.icon}</span>
          <h2 style={{ margin: 0, color: '#2d3748' }}>
            Bulk Price Update
          </h2>
        </div>

        <p style={{ color: '#718096', marginBottom: '24px' }}>
          Update prices for all {categoryInfo.label.toLowerCase()} at once
        </p>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#2d3748' }}>
              Change Type
            </label>
            <div style={{ display: 'flex', gap: '12px' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                <input
                  type="radio"
                  value="percentage"
                  checked={changeType === 'percentage'}
                  onChange={(e) => setChangeType(e.target.value)}
                />
                Percentage (%)
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                <input
                  type="radio"
                  value="fixed"
                  checked={changeType === 'fixed'}
                  onChange={(e) => setChangeType(e.target.value)}
                />
                Fixed Amount (₹)
              </label>
            </div>
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#2d3748' }}>
              {changeType === 'percentage' ? 'Percentage Change' : 'Amount Change'}
            </label>
            <input
              type="number"
              value={priceChange}
              onChange={(e) => setPriceChange(e.target.value)}
              required
              step={changeType === 'percentage' ? '0.1' : '0.01'}
              style={{
                width: '100%',
                padding: '12px',
                border: '2px solid #e2e8f0',
                borderRadius: '8px',
                fontSize: '16px',
                outline: 'none'
              }}
              placeholder={changeType === 'percentage' ? 'e.g., 10 for +10%' : 'e.g., 50 for +₹50'}
            />
            <p style={{ fontSize: '12px', color: '#718096', marginTop: '4px' }}>
              {changeType === 'percentage' 
                ? 'Use negative values to decrease (e.g., -10 for -10%)'
                : 'Use negative values to decrease (e.g., -50 for -₹50)'
              }
            </p>
          </div>

          <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              style={{
                padding: '12px 24px',
                border: '2px solid #e2e8f0',
                background: 'white',
                color: '#4a5568',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.6 : 1
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading || !priceChange}
              style={{
                padding: '12px 24px',
                border: 'none',
                background: loading ? '#9ca3af' : 'linear-gradient(45deg, #f59e0b, #d97706)',
                color: 'white',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: loading || !priceChange ? 'not-allowed' : 'pointer',
                minWidth: '120px'
              }}
            >
              {loading ? '⏳ Updating...' : 'Update Prices'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BulkPricingModal;